import { Chip, Tooltip, type ChipProps } from "@mui/material";

type DocumentScopeChipProps = {
  dataTestId?: string;
  label: string;
  maxWidth?: number | string;
  size?: ChipProps["size"];
  tooltipTitle?: string;
};

export const DocumentScopeChip = ({
  dataTestId = "document-scope-chip",
  label,
  maxWidth = 112,
  size = "xxs",
  tooltipTitle,
}: DocumentScopeChipProps) => (
  <Tooltip
    describeChild
    placement="top"
    title={tooltipTitle ?? `Scope: ${label}`}
  >
    <Chip
      data-testid={dataTestId}
      label={label}
      size={size}
      variant="outlined"
      sx={{
        flex: "0 1 auto",
        maxWidth,
        minWidth: 0,
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      }}
    />
  </Tooltip>
);
